import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const DealStructureSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const dealContent = content[language].dealStructure;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="deal" 
      ref={sectionRef}
      className="section"
      style={{ background: '#ffffff' }}
    >
      <div className="container-narrow">
        {/* Header */}
        <div className={`text-center mb-48 fade-in-up ${isVisible ? 'visible' : ''}`}>
          <h2 className="mb-32">{dealContent.title}</h2>
          <p style={{ fontSize: '1.0625rem' }}>{dealContent.model}</p>
        </div>

        {/* Capital Allocation */}
        <div style={{ marginTop: '64px', marginBottom: '48px' }}>
          {dealContent.allocation.map((item, index) => (
            <div
              key={item.category}
              className={`fade-in-up ${isVisible ? 'visible' : ''}`}
              style={{
                padding: '32px 40px',
                background: 'var(--ivory)',
                marginBottom: '24px',
                transitionDelay: `${0.2 + index * 0.15}s`
              }}
            >
              <h4 className="mb-12" style={{ fontSize: '1.125rem', fontWeight: 500 }}>
                {item.category}
              </h4>
              <p style={{ fontSize: '0.9375rem', margin: 0 }}>{item.description}</p>
            </div>
          ))}
        </div>

        {/* Note */}
        <div 
          className={`fade-in-up ${isVisible ? 'visible' : ''}`}
          style={{ 
            transitionDelay: '0.6s',
            padding: '24px 32px',
            background: '#ffffff',
            border: '1px solid var(--stone)',
            fontStyle: 'italic'
          }}
        >
          <p style={{ fontSize: '0.9375rem', margin: 0 }}>{dealContent.note}</p>
        </div>
      </div>
    </section>
  );
};

export default DealStructureSection;
